import React, { useEffect } from 'react';
import MeasurementPhoto from '../images/Measurement.png';
import styled from 'styled-components';

const StyledContainer = styled.div`
width: 100%;
margin: auto;
padding: 10px 0px 10px 0px;
`;

const MeasurementPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Measurement
        </div>
        <div style={{ margin: '10px 0px' }}>
        To make measurement, click Measurement tab. 
        </div>
        <div style={{ margin: '10px 0px' }}>
        In Measurement panel, click <strong>Enable</strong> to enable/disable measurement.
        </div>
        <div style={{ margin: '10px 0px' }}>
        When measurement enabled, double click object in the view will add a measurement point in the measurement panel. 
        </div>
        <div style={{ margin: '10px 0px' }}>
        To remove a measurement point, click Remove Icon at the right end of the line. 
        </div>
        <div style={{ margin: '10px 0px' }}>
        To remove all measurement points, click <strong>REMOVE ALL</strong> button. 
        </div>

        <StyledContainer>
            <img src={MeasurementPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

    </div>
  )
}

export default MeasurementPage;